<template>
    <div id="sidebar" class=" h-screen p-5 flex flex-col justify-between admin">
      <div class="flex flex-col sidebar-content">
        <!-- ANCHOR LOGO -->
        <router-link to="/" title="Retourner à l'accueil" class="w-2/3 my-5 mx-auto">
          <img :src="logo" alt="CodeSnippet" class="w-full m-auto" />
        </router-link>
        <nav class="flex-1">

          <div class="adminBar my-5">
            <span>Mode admin</span>
          </div>

          <div class="divider"></div>
          <router-link
            :to="{ name: 'Admin Dashboard' }"
            title="Dashboard administrateur"
          >
            <div class="nav-link">
              <Button
                class="p-button-link"
                icon="mdi-view-dashboard"
                icon-size="30"
                label="Dashboard"
              />
            </div>
          </router-link>
          <router-link
            to="/admin/users"
            title="Accéder à la liste des utilisateurs"
          >
            <div class="nav-link">
              <Button
                class="p-button-link"
                icon="mdi-account-supervisor-circle"
                icon-size="30"
                label="Utilisateurs"
              />
            </div>
          </router-link>
          <router-link
            to="/admin/projects"
            title="Accéder à la liste des projets"
          >
            <div class="nav-link">
              <Button
                class="p-button-link"
                icon="mdi-view-list"
                icon-size="30"
                label="Projets"
              />
            </div>
          </router-link>
          <span title="Se déconnecter">
            <div class="nav-link">
              <Button
                @click="logout()"
                class="p-button-link"
                icon="mdi-power"
                icon-size="30"
                label="Déconnexion"
              />
            </div>
          </span>
        </nav>
      </div>
      <div class="flex flex-col items-center justify-center">
        <!-- Dark Mode -->
        <Button
          :label="this.$store.state.dark ? 'Mode clair' : 'Mode sombre'"
          @click="darkMode"
          v-tooltip="{ content: themeTooltip, placement: 'right' }"
          :icon="this.$store.state.dark ? 'mdi-white-balance-sunny' : 'mdi-moon-waning-crescent'"
          :icon-size="20"
        />
        <div class="flex mt-5">
          <!-- Links -->
          <router-link class="link" :to="{ name: 'Guide' }">
            <span>Guide</span>
          </router-link>
          &nbsp;-&nbsp;
          <router-link class="link" to="/">
            <span>Accueil</span>
          </router-link>
        </div>
        <div class="mt-2 mb-5 flex flex-col items-center">
          <!-- Links -->
          <router-link class="link" :to="{ name: 'CGU' }">
            <span>Conditions d'utilisation</span>
          </router-link>
          <!-- 
          <router-link class="link" :to="{ name: 'Policy' }">
            <span>Politique de confidentialité</span>
          </router-link>
          -->
        </div>
        <div class="mt-5 flex flex-col items-center">
          <span>© {{ new Date().getFullYear() }} - CodeSnippet</span>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import logo from "~/assets/logo.png";

export default {
  name: "SideBar",
  data: () => ({
    logo: logo,
    projects: [
      {
        id: "0458422ef",
        title: "TD3 Exercice JavaScript",
      },
      {
        id: "0458422ef",
        title: "TD1 Exercice JavaScript",
      },
    ],
  }),
  computed: {
    themeTooltip() {
      if( this.$store.state.dark ) return 'Activer le thème clair';
      else return 'Activer le thème sombre';
    }
  },
  methods: {
    ...mapActions({
      logoutStore: 'auth/logout',
    }),
    logout() {
      this.logoutStore().then(() => {
        this.$router.push({ name: 'Accueil' });
      });
    },
    darkMode() {
      const currentTheme = !this.$store.state.dark;

      this.$store.commit('changeState', {
        key: 'dark',
        data: currentTheme,
      });
      this.$dark(currentTheme);
    },
  },
};
</script>
